import PayBox from './PayBox.vue'
import { Tabs, message } from 'ant-design-vue'

/* istanbul ignore next */
PayBox.install = function (Vue) {
  Vue.component(PayBox.name, PayBox)
  Vue.use(Tabs)
  Vue.prototype.$message = message
}

export default PayBox
